define('share',['jquery', 'underscore', 'lib'], function($, _, lib) {
    'use strict';

    return {
        shareButtons: null,
        init: function() {
            this.shareButtons = $('.share');

            this.shareButtons.find('a.facebook').attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + lib.getShareUrl()).attr('target', '_blank');
            this.shareButtons.find('a.twitter').attr('href', 'https://twitter.com/share?url=' + lib.getShareUrl()).attr('target', '_blank');
            this.shareButtons.find('a.linkedin').attr('href', 'http://www.linkedin.com/shareArticle?mini=true&url=' + lib.getShareUrl()).attr('target', '_blank');
            this.shareButtons.find('a.mail').attr('href', 'mailto:?subject='+ encodeURIComponent('Tips: E24.no') +'&body=' + window.location.href).attr('target', '_blank');
            this.shareButtons.find('a.print').on('click', function(e) {e.preventDefault(); window.print(); });

            if (lib.isDesktop() && !lib.isTablet()) {
                this.enablePopups();
            }
        },
        enablePopups: function() {
            var hidden = this.shareButtons.find('.hidden');
            this.shareButtons.on('click', '.facebook', function(e) {
                e.preventDefault();
                window.open(
                    'https://www.facebook.com/sharer/sharer.php?u=' + lib.getShareUrl(),
                    'facebook',
                    'width=720,height=275,resizable,scrollbars=no,status=1'
                );
            }).on('click', '.twitter', function(e) {
                e.preventDefault();
                var url = 'https://twitter.com/share?';

                if (lib.getRoute() === 'article') {
                    url += 'text=' + encodeURIComponent($('h1[itemprop="name"]').text()) + '&';
                }

                url += 'url=' + lib.getShareUrl();

                window.open(url,
                    'twitter',
                    'width=720,height=275,resizable,scrollbars=no,status=1'
                );
            }).on('click', '.linkedin', function(e) {
                e.preventDefault();
                window.open(
                    'https://www.linkedin.com/shareArticle?mini=true&url=' + lib.getShareUrl(),
                    'linkedin',
                    'width=720,height=275,resizable,scrollbars=no,status=1'
                );
            }).on('click', '.mail', function(e) {
                e.preventDefault();
                window.location.href = 'mailto:?subject=Tips: Artikkel på e24.no&body=' + window.location.href;
            }).on('click', '.more', function(e) {
                e.preventDefault();
                $(this).toggleClass('active');
                hidden.toggleClass('visible');
            });
        },
    };
});

